import { isEmpty } from 'lodash';
import React from 'react';
import { EventTO, toEventTO } from '../../../../../lib';
import { calculateTimeGap } from '../../../../helpers';

interface WithingsCommunicationFormatterProps {
  data: any;
  id: string;
}

const WithingsCommunicationFormatter = ({
  data,
  id,
}: WithingsCommunicationFormatterProps) => {
  const withingsData: EventTO[] = (data?.withingsData || []).map(toEventTO);
  const lastestWithingsData = withingsData.sort(
    (a, b) => new Date(b.eventDate).getTime() - new Date(a.eventDate).getTime(),
  )[0];

  if (isEmpty(lastestWithingsData)) {
    return <div id={id}>-</div>;
  }
  return (
    <div id={id}>
      {calculateTimeGap(
        new Date().toISOString(),
        new Date(lastestWithingsData.eventDate).toISOString(),

        {
          hourFormat: 'hrs',
          daysFormat: 'days',
          monthsFormat: 'months',
        },
      )}
      {lastestWithingsData.name && (
        <span> - {lastestWithingsData.name} recording</span>
      )}
    </div>
  );
};

export default WithingsCommunicationFormatter;
